import React, { FunctionComponent } from 'react';
import { ImageLinkModel } from '../navigationItem/models/navigationItem.model';
import { withSitecoreContext, Image } from '@sitecore-jss/sitecore-jss-react';
import { TSitecoreContext } from '../../../../types/types';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';

const ImageLink: FunctionComponent<{ model: ImageLinkModel; onClick?: () => void; sitecoreContext: TSitecoreContext }> = ({
  model,
  onClick,
  sitecoreContext,
}) => {
  const isEEActive = sitecoreContext?.pageEditing;
  if (isEEActive) {
    // allow easier editing on Experience editor
    return (
      <div className="navigation-link navigation-link--image">
        <span className="navigation-link__image-wrapper">
          <Image field={model.image} className="navigation-link__image" loading="lazy" />
        </span>
        <span className="navigation-link__text-wrapper">
          <CustomExternalAnchor field={model.link} className="navigation-link__text" />
        </span>
      </div>
    );
  }
  return (
    <RoutableSitecoreLink field={model.link} className="navigation-link navigation-link--image" onClick={onClick}>
      <span className="navigation-link__image-wrapper">
        <Image field={model.image} className="navigation-link__image" loading="lazy" />
      </span>
      <span className="navigation-link__text-wrapper">
        <span className="navigation-link__text">{model.linkText}</span>
      </span>
    </RoutableSitecoreLink>
  );
};

export default withSitecoreContext()(ImageLink);
